import * as React from "react";

import { SvgIcon, SvgIconProps } from "@mui/material";

export function ArrowDownIcon({ className, ...props }: SvgIconProps) {
  return (
    <SvgIcon
      className={className}
      sx={(theme) => ({
        width: theme.spacing(2),
        height: theme.spacing(1),
      })}
      viewBox="0 0 16 8"
      style={{ order: -1 }}
      {...props}>
      <svg width="16" height="8" viewBox="0 0 16 8" fill="none">
        <path
          d="M1 1L8 7L15 1"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </SvgIcon>
  );
}
